import { render, staticRenderFns } from "./PointSale.vue?vue&type=template&id=a4d5f37c&"
import script from "./PointSale.vue?vue&type=script&lang=js&"
export * from "./PointSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports